// extracted by mini-css-extract-plugin
module.exports = {"navbar":"NavBar_navbar__1YhL4","active":"NavBar_active__3Tb7-","landscapeDisplayNone":"NavBar_landscapeDisplayNone__YZfwn"};